<template>
  <div class="app-select">
    <label class="app-select--label">{{ label }}: </label>
    <div class="app-select--content">
      <div class="option-group" v-if="optionsWithAny.length">
        <span v-for="(item,index) in optionsWithAny" :key="index" class="capitalize" :class="{ 'app-select--option': true, 'is-active': selected.includes(item.id) }" @click="onSelect(item)" v-if="item.type === type || type === 'common' || item.type === 'common'">
          <font-icon v-if="multiple && index" :id="selected.includes(item.id) ? 'check-box-outline' :'check-box-outline-bl'"></font-icon> {{ getTranslatation(item.name) | langFilter }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import langFilter from '@/common/vfilter.lang'

export default {
  props: {
    label: String,
    options: Array,
    name: String,
    default: Array, // 默认选择项的id
    allowCancel: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
    any: { type: Object, default: null }, // 存在any，则添加一个”不限“选项
    objitem: { type: Object, default: null },
    type: { type: String, default: 'common' },
  },
  data() {
    return {
      selected: this.default ? [...this.default] : [], // 选项的 ID List
      optionsWithAny: [],
    }
  },
  filters: {
    langFilter,
  },
  methods: {
    onSelect(item) {
      if (!this.allowCancel && this.selected.includes(item.id)) return

      if (this.selected.includes(item.id)) {
        if (this.allowCancel) {
          // 取消选中
          const temp = [...this.selected]
          const i = temp.indexOf(item.id)
          temp.splice(i, i + 1)
          this.selected = temp
          return this.$emit('change', { name: this.name, selected: this.selected })
        }
      }

      if (this.multiple) {
        if (this.any) {
          // 多选 且存在'不限'
          if (item.id === this.any.id) {
            this.selected = [this.any.id]
            return this.$emit('change', { name: this.name, selected: this.selected })
          } else {
            // 取消选中'不限'
            const temp = [...this.selected]
            const itemAnyIndex = temp.indexOf(this.any.id)
            if (itemAnyIndex > -1) temp.splice(itemAnyIndex, 1)
            this.selected = temp
          }
        }

        // 允许多选
        this.selected.push(item.id)
        return this.$emit('change', { name: this.name, selected: this.selected })
      }

      this.selected = [item.id]
      this.$emit('change', { name: this.name, selected: this.selected })
    },
    setSelect(idList) {
      this.selected = idList
    },
    getTranslatation(text){
      // 对一些特殊选项增加多语言处理

      if(text['en-US'] === 'single' || text['en-US'] === 'multi'){

        return this.$t('filterBar.' + text['en-US'])
      }
      return text
    }
  },
  watch: {
    options: {
      immediate: true,
      handler(val) {
        // console.log(this.label, this.options)
        let tempArr = val
        if (val && val.length) {
          if (typeof val[0] === 'string') {
            tempArr = val.map(str => ({
              id: str,
              name: {
                'en-US': str,
                'zh-CN': str,
              },
            }))
          }
        }

        let optionsWithAny = []
        if (this.any) optionsWithAny.push(this.any)
        if (tempArr) optionsWithAny = optionsWithAny.concat(tempArr)
        if (this.objitem && this.objitem.addon) optionsWithAny = optionsWithAny.concat(this.objitem.addon)
        this.optionsWithAny = optionsWithAny
      },
    },
  },
}

</script>